import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ErrorBoundary } from '../components/ErrorBoundary'
import { BusinessClaim } from '../components/BusinessClaim'

import '../i18n'
import '../components/App.css'

// Kyb Business Claim Params
import KybParams from '../components/kyb_params.json'

const intlTelInput = document.createElement('script');
intlTelInput.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.4/build/js/intlTelInput.min.js';
document.head.appendChild(intlTelInput);

const App = () => {
  let kybParams = JSON.parse((document.getElementById('kyb_params') as HTMLInputElement)?.value || JSON.stringify(KybParams));

  return (
    <ErrorBoundary>
      <BusinessClaim {...kybParams} />
    </ErrorBoundary>
  )
}

createRoot(document.getElementById('kyb_app')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)